/**
 * An object containing properties for table events
 */
var TableEvent = /** @class */ (function () {
    function TableEvent() {
    }
    return TableEvent;
}());
export { TableEvent };
//# sourceMappingURL=table-event.js.map